// ==================================================
// SMOOTH SCROLL HELPER (avoids curly braces in HTML onclick)
// ==================================================
function skSmoothScroll(id) {
  var el = document.getElementById(id);
  if (el) el.scrollIntoView({behavior: 'smooth'});
}

// ==================================================
// ROTATING TESTIMONIAL (moved from inline script)
// ==================================================
var reviewsList = [
  { name: 'Misha F.', hook: '"My husband stopped snoring the first night."', body: ' I bought this skeptically and now we\'re on month 4 of a subscription. It genuinely changed our sleep.' },
  { name: 'Sarah K.', hook: '"No more waking up with dry mouth."', body: ' I used to chug water at 3am every night. Two weeks in and that\'s completely gone.' },
  { name: 'David M.', hook: '"My wife recorded me \u2014 zero snoring."', body: ' She couldn\'t believe it. I wake up feeling 10 years younger. We\'re both subscribers now.' },
  { name: 'Laura W.', hook: '"I finally sleep through the night."', body: ' No more 2am wake-ups.' },
  { name: 'James R.', hook: '"Morning brain fog is completely gone."', body: ' I feel sharp by 7am instead of dragging until noon. My therapist even noticed the energy shift.' },
  { name: 'Kate N.', hook: '"Perfect for sensitive skin."', body: ' I was worried about irritation. Zero issues. The bamboo feels incredibly soft and leaves no residue at all.' },
  { name: 'Carlos A.', hook: '"My dentist noticed before I told her."', body: ' She said my oral health had visibly improved. Science checks out.' },
  { name: 'Ben H.', hook: '"Third month subscriber. Never going back."', body: ' My energy levels are finally consistent throughout the day. This is the simplest health upgrade I\'ve ever made.' },
  { name: 'Sofia M.', hook: '"The under-eye bags are actually fading."', body: ' I thought it was just marketing but proper nasal breathing really does reduce puffiness. Friends keep asking what I changed.' },
  { name: 'Rachel T.', hook: '"Replaced my mouth guard entirely."', body: ' I used to grind my teeth from mouth breathing. Taping changed my jaw position overnight. Dentist confirmed less wear.' }
];
var currentReviewIndex = 0;
function showReview(i) {
  if (i < 0) i = reviewsList.length - 1;
  if (i >= reviewsList.length) i = 0;
  currentReviewIndex = i;
  var r = reviewsList[i];
  var contentEl = document.getElementById('review-content');
  if (!contentEl) return; // Element not in DOM yet
  contentEl.style.opacity = '0';
  setTimeout(function() {
    contentEl.innerHTML = '<div class="mini-testimonial-top"><span class="mini-testimonial-stars">\u2605\u2605\u2605\u2605\u2605</span><span class="mini-testimonial-name">' + r.name + '</span><span class="verified-badge">\u2713 Verified Buyer</span></div><div class="mini-testimonial-text"><strong>' + r.hook + '</strong>' + r.body + '</div>';
    contentEl.style.opacity = '1';
  }, 250);
  var prevBtn = document.getElementById('review-prev');
  var nextBtn = document.getElementById('review-next');
  if (prevBtn) prevBtn.classList.remove('hidden');
  if (nextBtn) nextBtn.classList.remove('hidden');
}

// Initialize testimonial — use DOMContentLoaded if DOM isn't ready yet
function initTestimonial() {
  var start = -1;
  var root = document.getElementById('rotating-testimonial');
  var pinned = root && root.getAttribute('data-first-review');
  if (pinned) {
    for (var i = 0; i < reviewsList.length; i++) {
      if (reviewsList[i].name === pinned) {
        start = i;
        break;
      }
    }
  }
  if (start < 0) start = Math.floor(Math.random() * reviewsList.length);
  showReview(start);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTestimonial);
} else {
  initTestimonial();
}

// ==================================================
// PRODUCT DATA — All variant IDs, selling plans, pricing
// ==================================================
// Product-aware pages (e.g. templates/product.mouth-tape-b.json via
// sections/sk-pdp-buybox-b-product.liquid) set `window.SK_PRODUCT` from the live
// `product` object BEFORE this deferred script runs, so the buy box uses real
// variant + Skio selling-plan IDs with no drift. Pages that don't set it (the
// custom /pages/mouth-tape-* templates) fall back to the hardcoded values below,
// so their behaviour is unchanged.
const PRODUCT = window.SK_PRODUCT || {
  variants: {
    'full-1':  { id: 46066516656369, title: 'Full coverage / 1 Month Supply' },
    'full-3':  { id: 46072098324721, title: 'Full coverage / 3 Months Supply' },
    'full-6':  { id: 46072098357489, title: 'Full coverage / 6 Months Supply' },
    'slim-1':  { id: 46066516721905, title: 'Slim profile / 1 Month Supply' },
    'slim-3':  { id: 46072098390257, title: 'Slim profile / 3 Months Supply' },
    'slim-6':  { id: 46072098423025, title: 'Slim profile / 6 Months Supply' },
  },
  sellingPlans: {
    '1': { id: 5171773681, price: 3497, label: '$34.97', save: '30%' },
    '3': { id: 5171740913, price: 2747, label: '$27.47', save: '45%' },
    '6': { id: 5171806449, price: 2498, label: '$24.98', save: '50%' },
  },
  oneTimePricePerMonth: 4995,
  // Pack pricing — one-time totals
  packs: {
    '1': { months: 1, oneTimeTotal: '$49.95',   oneTimeOrig: null,       perMonth: '$49.95' },
    '3': { months: 3, oneTimeTotal: '$149.85',  oneTimeOrig: null,       perMonth: '$49.95' },
    '6': { months: 6, oneTimeTotal: '$299.70',  oneTimeOrig: null,       perMonth: '$49.95' },
  },
  // Subscription totals per pack
  subPacks: {
    '1': { total: '$34.97',  orig: '$49.95',  perMonth: '$34.97', save: '30%' },
    '3': { total: '$82.41',  orig: '$149.85', perMonth: '$27.47', save: '45%' },
    '6': { total: '$149.88', orig: '$299.70', perMonth: '$24.98', save: '50%' },
  },
};

// ==================================================
// STATE
// ==================================================
let state = {
  style: 'full',        // 'full' or 'slim'
  pack: '3',            // '1', '3', or '6' — default to 3 month (most popular)
  isSubscription: true,  // refill toggle on by default
};

// ==================================================
// IMAGE GALLERY
// ==================================================
const galleryHeroImages = {
  full: 'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/SK_Award_Winning_--_updated_NEW_Large_3cfc311e-dc77-4d80-9fd9-fae207889fed.webp?v=1772825344',
  slim: 'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/slimprofile.webp?v=1773271889'
};
const galleryImages = [
  galleryHeroImages.full,
  'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/Mouth_tape_hero_2_Large_64ddd17d-4c54-40ec-8dbb-1f6e4e5d7d3f.jpg',
  'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/Mouth-Tape-3.jpg',
  'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/Mouth-Tape-6.jpg',
  'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/Mouth-Tape-5.jpg',
  'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/Mouth-Tape-8.jpg',
  'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/Mouth-Tape-11.jpg',
  'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/Mouth-Tape-7.jpg',
];

let currentImageIndex = 0;
function setImage(index) {
  currentImageIndex = index;
  document.getElementById('main-image').src = galleryImages[index];
  document.getElementById('gallery-counter').textContent = (index + 1) + ' / ' + galleryImages.length;
  document.querySelectorAll('.gallery-thumb').forEach((t, i) => {
    t.classList.toggle('active', i === index);
  });
  // Show/hide arrows based on position
  const prevBtn = document.querySelector('.gallery-arrow.prev');
  const nextBtn = document.querySelector('.gallery-arrow.next');
  if (prevBtn) prevBtn.classList.toggle('hidden', index === 0);
  if (nextBtn) nextBtn.classList.toggle('hidden', index === galleryImages.length - 1);
}
function prevImage() {
  if (currentImageIndex > 0) setImage(currentImageIndex - 1);
}
function nextImage() {
  if (currentImageIndex < galleryImages.length - 1) setImage(currentImageIndex + 1);
}

// Swipe support (touch + mouse drag)
(function() {
  var el = document.getElementById('gallery-main');
  if (!el) return;
  var startX, startY, isDragging = false;

  // Prevent native image drag on ALL images inside gallery
  var imgs = el.getElementsByTagName('img');
  for (var i = 0; i < imgs.length; i++) {
    imgs[i].draggable = false;
    imgs[i].addEventListener('dragstart', function(e) { e.preventDefault(); });
  }

  function getX(e) {
    if (e.touches) return e.touches[0].clientX;
    return e.clientX;
  }
  function getY(e) {
    if (e.touches) return e.touches[0].clientY;
    return e.clientY;
  }
  function getEndX(e) {
    if (e.changedTouches) return e.changedTouches[0].clientX;
    return e.clientX;
  }
  function getEndY(e) {
    if (e.changedTouches) return e.changedTouches[0].clientY;
    return e.clientY;
  }

  function onStart(e) {
    isDragging = true;
    startX = getX(e);
    startY = getY(e);
    // Only preventDefault for mouse (not touch, to allow scroll)
    if (!e.touches) e.preventDefault();
  }
  function onEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    var dx = getEndX(e) - startX;
    var dy = getEndY(e) - startY;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) { nextImage(); } else { prevImage(); }
    }
  }
  function onCancel() { isDragging = false; }

  // Touch
  el.addEventListener('touchstart', onStart, { passive: true });
  el.addEventListener('touchend', onEnd);
  el.addEventListener('touchcancel', onCancel);

  // Mouse
  el.addEventListener('mousedown', onStart);
  window.addEventListener('mouseup', onEnd);
  window.addEventListener('mouseleave', onCancel);

  // Also set cursor style
  el.style.cursor = 'grab';
  el.addEventListener('mousedown', function() { el.style.cursor = 'grabbing'; });
  window.addEventListener('mouseup', function() { el.style.cursor = 'grab'; });
})();

// ==================================================
// VARIANT / STYLE SELECTION (tape shape)
// ==================================================
function selectStyle(el, style) {
  state.style = style;
  document.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
  el.classList.add('selected');

  // Swap hero gallery image to match selected variant
  galleryImages[0] = galleryHeroImages[style];
  var firstThumb = document.querySelector('.gallery-thumb img');
  if (firstThumb) firstThumb.src = galleryHeroImages[style];
  setImage(0);

  updateUI();
}

// ==================================================
// PACK SELECTION
// ==================================================
function selectPack(pack) {
  state.pack = pack;
  document.querySelectorAll('.pack-card').forEach(c => c.classList.remove('selected'));
  document.querySelector('.pack-card[data-pack="' + pack + '"]').classList.add('selected');
  updatePackCards();
  updateUI();
}

// ==================================================
// REFILL / SUBSCRIBE TOGGLE
// ==================================================
function toggleRefill() {
  state.isSubscription = !state.isSubscription;
  const toggle = document.getElementById('refill-toggle');
  const check = document.getElementById('refill-check');
  toggle.classList.toggle('active', state.isSubscription);
  document.getElementById('refill-row').classList.toggle('active', state.isSubscription);
  check.textContent = state.isSubscription ? '✓' : '';
  document.querySelector('.pack-cards').classList.toggle('compact', !state.isSubscription);
  var bestDeal = document.querySelector('.pack-badge.best-deal');
  if (bestDeal) bestDeal.style.display = state.isSubscription ? '' : 'none';
  updatePackCards();
  updateUI();
}

// ==================================================
// UPDATE PACK CARD PRICES (when toggling subscription)
// ==================================================
function updatePackCards() {
  ['1', '3', '6'].forEach(p => {
    const perMonthEl = document.getElementById('pack-' + p + '-permonth');
    const origEl = document.getElementById('pack-' + p + '-orig');
    const totalEl = document.getElementById('pack-' + p + '-total');
    const discountEl = document.getElementById('pack-' + p + '-discount');

    if (state.isSubscription) {
      const sub = PRODUCT.subPacks[p];
      perMonthEl.innerHTML = sub.perMonth + '<span class="pack-price-permonth-label">/mo</span>';
      origEl.textContent = PRODUCT.packs[p].perMonth;
      origEl.style.visibility = 'visible';
      discountEl.textContent = sub.save + ' OFF';
      discountEl.style.display = '';
      if (totalEl) { totalEl.textContent = sub.total + ' total'; }
    } else {
      const pack = PRODUCT.packs[p];
      perMonthEl.innerHTML = pack.perMonth + '<span class="pack-price-permonth-label">/pack</span>';
      origEl.style.visibility = 'hidden';
      discountEl.style.display = 'none';
      if (totalEl) {
        totalEl.textContent = pack.oneTimeTotal + ' total';
      }
    }
  });

  // Update "You save $X" box — calculate actual dollar savings
  const saveBox = document.getElementById('refill-save-box');
  if (state.isSubscription) {
    const months = parseInt(state.pack);
    const oneTimeTotal = PRODUCT.oneTimePricePerMonth * months; // in cents
    const subTotal = parseFloat(PRODUCT.subPacks[state.pack].total.replace('$', '').replace(',', '')) * 100;
    const saved = ((oneTimeTotal - subTotal) / 100).toFixed(2);
    saveBox.textContent = 'You save $' + saved;
    // Also update CTA savings line
    const ctaSavings = document.getElementById('cta-savings-line');
    if (ctaSavings) {
      ctaSavings.innerHTML = 'You save <span>$' + saved + '</span> on this order';
      ctaSavings.style.display = 'block';
    }
  } else {
    const ctaSavings = document.getElementById('cta-savings-line');
    if (ctaSavings) ctaSavings.style.display = 'none';
  }

  // Toggle subscription benefits + delivery line visibility
  document.querySelectorAll('.pack-benefits, .pack-deliver').forEach(el => {
    if (state.isSubscription) {
      el.classList.add('visible');
    } else {
      el.classList.remove('visible');
    }
  });
}

// ==================================================
// UI UPDATE — main price row, CTA, sticky bar
// ==================================================
function updateUI() {
  const total = state.isSubscription
    ? PRODUCT.subPacks[state.pack].total
    : PRODUCT.packs[state.pack].oneTimeTotal;
  const origTotal = state.isSubscription ? PRODUCT.subPacks[state.pack].orig : null;

  // addToCart() replaces #add-to-cart-btn innerHTML with "Adding…" / "Added!",
  // which removes #cta-price. Writing textContent on that missing node throws
  // and never reaches the sticky update, so both START NOW prices freeze on
  // the selection from the first add until a full reload. Rebuild the main
  // button from current state instead (same approach as sk-nose-pdp.js).
  // Cart open/close does not touch these nodes; only this updater writes them.
  resetCTAButton();

  const stickyPriceEl = document.getElementById('sticky-price');
  if (!stickyPriceEl) return;
  if (state.isSubscription) {
    stickyPriceEl.innerHTML = total + ' <span style="text-decoration:line-through;color:var(--gray-400);font-weight:400;">' + origTotal + '</span>';
  } else {
    stickyPriceEl.textContent = total;
  }
}

// ==================================================
// START NOW — Shopify AJAX Cart API
// ==================================================
function addToCart() {
  const btn = document.getElementById('add-to-cart-btn');
  const successEl = document.getElementById('cart-success');

  // Determine the correct variant ID (style + pack size)
  const variantKey = state.style + '-' + state.pack;
  const variant = PRODUCT.variants[variantKey];

  if (!variant) {
    alert('Error: Could not find variant. Please try again.');
    return;
  }

  // Build the cart payload — quantity matches the pack size (1, 3, or 6)
  const packQuantity = parseInt(state.pack, 10) || 1;
  const payload = { id: variant.id, quantity: packQuantity };

  // Add selling plan if subscription
  if (state.isSubscription) {
    payload.selling_plan = PRODUCT.sellingPlans[state.pack].id;
  }

  // Show loading state
  btn.classList.add('loading');
  btn.innerHTML = '⏳ Adding to cart...';

  // Get the section IDs the cart drawer needs for rendering
  var cartDrawer = document.querySelector('cart-drawer');
  var drawerSections = cartDrawer && cartDrawer.getSectionsToRender
    ? cartDrawer.getSectionsToRender().map(function(s) { return s.id; })
    : ['cart-drawer', 'cart-icon-bubble'];

  // Call Shopify AJAX Cart API — include sections so response has pre-rendered HTML
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [payload], sections: drawerSections.join(',') }),
  })
  .then(response => {
    if (!response.ok) throw new Error('Cart API returned ' + response.status);
    return response.json();
  })
  .then(data => {
    btn.classList.remove('loading');
    const total = state.isSubscription ? PRODUCT.subPacks[state.pack].total : PRODUCT.packs[state.pack].oneTimeTotal;
    btn.innerHTML = '✅ Added!';

    // Use the theme's native cart drawer methods:
    // 1. renderContents() updates the drawer HTML with fresh cart data
    // 2. After a brief delay (DOM needs to settle after innerHTML swap),
    //    toggleDrawerClasses() opens the drawer (adds open attr + CSS classes)
    if (cartDrawer && cartDrawer.renderContents && data.sections) {
      cartDrawer.renderContents(data, true);
      setTimeout(function() {
        if (!cartDrawer.isOpen) {
          cartDrawer.toggleDrawerClasses();
        }
      }, 100);
    } else {
      // Fallback: click the cart trigger after a delay
      setTimeout(function() {
        var cartTrigger = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, a[href="/cart"]');
        if (cartTrigger) cartTrigger.click();
      }, 500);
    }

    setTimeout(() => { resetCTAButton(); }, 3000);
  })
  .catch(error => {
    btn.classList.remove('loading');
    const isShopify = window.location.hostname.includes('sleepkarma') || window.location.hostname.includes('myshopify');

    if (isShopify) {
      btn.innerHTML = '❌ Error — please try again';
      setTimeout(() => { resetCTAButton(); }, 2000);
    } else {
      // Preview mode
      const price = state.isSubscription ? PRODUCT.subPacks[state.pack].total : PRODUCT.packs[state.pack].oneTimeTotal;
      successEl.innerHTML = '<div class="cart-success-text">🔧 Preview Mode — This would add to cart:</div>' +
        '<div style="font-size:13px;color:#555;margin-bottom:8px;">' +
        'Variant: <strong>' + variant.title + '</strong> (ID: ' + variant.id + ')<br>' +
        (state.isSubscription ? 'Selling Plan: <strong>' + state.pack + '-month subscription</strong> (ID: ' + PRODUCT.sellingPlans[state.pack].id + ')<br>' : 'One-time purchase<br>') +
        'Price: <strong>' + price + '</strong></div>' +
        '<div style="font-size:12px;color:#999;">When this HTML is on sleepkarma.co, it will POST to /cart/add.js and redirect to checkout.</div>';
      successEl.classList.add('show');
      resetCTAButton();
    }
  });
}

function resetCTAButton() {
  const btn = document.getElementById('add-to-cart-btn');
  if (!btn) return;
  const total = state.isSubscription ? PRODUCT.subPacks[state.pack].total : PRODUCT.packs[state.pack].oneTimeTotal;
  const origTotal = state.isSubscription ? PRODUCT.subPacks[state.pack].orig : '';
  btn.innerHTML = '<span class="cta-lock"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span> START NOW — <span class="cta-price" id="cta-price">' + total + '</span>' + (state.isSubscription ? ' <span class="cta-original" id="cta-original">' + origTotal + '</span>' : '');
}

// ==================================================
// BB FAQ TOGGLE — lock scroll position for full animation
// ==================================================
function bbFaqToggle(btn) {
  var scrollY = window.scrollY;
  btn.parentElement.classList.toggle('open');
  // Lock scroll for the entire 450ms transition
  var id = setInterval(function() { window.scrollTo(0, scrollY); }, 16);
  setTimeout(function() { clearInterval(id); }, 500);
}

// ==================================================
// STICKY BAR — IntersectionObserver
// ==================================================
// Initialize UI
updatePackCards();
updateUI();

// Sticky bar — deferred to ensure DOM is ready
(function initStickyBar() {
  var heroCta = document.getElementById('add-to-cart-btn');
  var finalCta = document.querySelector('.final-cta-button');
  var stickyBar = document.getElementById('sticky-bar');
  if (!heroCta || !stickyBar) return;
  var heroBelowViewport = false, finalCtaVisible = false;
  var stickyUpdate = function() { stickyBar.classList.toggle('visible', heroBelowViewport && !finalCtaVisible); };
  var heroObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      heroBelowViewport = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyUpdate();
    });
  }, { threshold: 0 });
  heroObs.observe(heroCta);
  if (finalCta) {
    var finalObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { finalCtaVisible = e.isIntersecting; stickyUpdate(); });
    }, { threshold: 0.1 });
    finalObs.observe(finalCta);
  }
})();

// ==================================================
// MATERIALS HOTSPOT INTERACTION
// ==================================================
document.querySelectorAll('.mat-hotspot').forEach(dot => {
  dot.addEventListener('mouseenter', () => {
    const id = dot.dataset.pin;
    // Show matching pin label
    document.querySelectorAll('.mat-pin').forEach(pin => {
      pin.classList.toggle('visible', pin.dataset.pinTarget === id);
    });
    // Dim other hotspots
    document.querySelectorAll('.mat-hotspot').forEach(d => {
      d.style.opacity = d.dataset.pin === id ? '1' : '0.3';
    });
  });
  dot.addEventListener('mouseleave', () => {
    document.querySelectorAll('.mat-pin').forEach(pin => pin.classList.remove('visible'));
    document.querySelectorAll('.mat-hotspot').forEach(d => { d.style.opacity = '1'; });
  });
});

// ==================================================
// MATERIALS VARIANT SWITCHER
// ==================================================
const variantData = {
  full: { label: 'Full Coverage', desc: 'Full Coverage for a full mouth seal.<br>Perfect for those who want a complete, snug fit.' },
  slim: { label: 'Slim Profile', desc: 'Slim Profile lies vertically across the lips for minimal feel.<br>Perfect for beginners or those with extra sensitive skin.' }
};
let currentVariant = 'full';
function goToVariant(v) {
  if (v === currentVariant) return;
  const panels = document.querySelectorAll('.variant-slide-panel');
  const exitIdx = currentVariant === 'full' ? 0 : 1;
  // Fade out the panel we're leaving
  panels[exitIdx].classList.add('exiting');
  currentVariant = v;
  document.getElementById('variantSlide').classList.toggle('show-slim', v === 'slim');
  document.getElementById('variantDesc').innerHTML = variantData[v].desc;
  document.querySelectorAll('.variant-pill-btn').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.variant === v);
  });
  document.querySelector('.variant-arrow.arrow-left').classList.toggle('disabled', v === 'full');
  document.querySelector('.variant-arrow.arrow-right').classList.toggle('disabled', v === 'slim');
  // Toggle nav hint arrows — hide outgoing immediately, show incoming after slide completes
  if (v === 'slim') {
    document.getElementById('slideHintRight').style.display = 'none';
    setTimeout(() => { document.getElementById('slideHintLeft').style.display = ''; }, 1200);
  } else {
    document.getElementById('slideHintLeft').style.display = 'none';
    setTimeout(() => { document.getElementById('slideHintRight').style.display = ''; }, 1200);
  }
  // Remove exiting class after transition completes
  setTimeout(() => { panels[exitIdx].classList.remove('exiting'); }, 1100);
}
function switchVariant(dir) {
  if (dir === 'next' && currentVariant === 'full') goToVariant('slim');
  if (dir === 'prev' && currentVariant === 'slim') goToVariant('full');
}

// Drag / swipe to switch variant
(function() {
  var wrapper = document.querySelector('.variant-slide-wrapper');
  var startX = 0, isDragging = false, threshold = 60;

  function onStart(e) {
    isDragging = true;
    startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    wrapper.style.cursor = 'grabbing';
  }
  function onEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    wrapper.style.cursor = 'grab';
    var endX = e.type.includes('mouse') ? e.clientX : e.changedTouches[0].clientX;
    var diff = endX - startX;
    if (diff < -threshold) switchVariant('next');
    else if (diff > threshold) switchVariant('prev');
  }
  function onCancel() { isDragging = false; wrapper.style.cursor = 'grab'; }

  wrapper.addEventListener('mousedown', onStart);
  window.addEventListener('mouseup', onEnd);
  window.addEventListener('mouseleave', onCancel);
  wrapper.addEventListener('touchstart', onStart, { passive: true });
  wrapper.addEventListener('touchend', onEnd);
})();

// ==================================================
// HERO MINI-FAQ TOGGLE
// ==================================================
function toggleHeroFAQ(btn) {
  const item = btn.parentElement;
  const answer = item.querySelector('.hero-faq-a');
  const isOpen = item.classList.contains('open');

  if (isOpen) {
    answer.style.maxHeight = '0';
    answer.style.padding = '0 18px';
    item.classList.remove('open');
  } else {
    item.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.padding = '0 18px 14px';
  }
}

// ==================================================
// FAQ TOGGLE (smooth animated version)
// ==================================================
function toggleFAQ(btn) {
  const item = btn.parentElement;
  const answer = item.querySelector('.faq-answer');
  const isOpen = item.classList.contains('open');

  if (isOpen) {
    answer.style.maxHeight = '0';
    answer.style.padding = '0';
    item.classList.remove('open');
  } else {
    item.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.padding = '0 0 20px';
  }
}

// Initialize open FAQ items
document.querySelectorAll('.faq-item.open .faq-answer').forEach(answer => {
  answer.style.maxHeight = answer.scrollHeight + 'px';
  answer.style.padding = '0 0 20px';
});

// ==================================================
// READING PROGRESS BAR
// ==================================================
let lastScrollY = 0;
const nav = document.querySelector('.nav');
window.addEventListener('scroll', function() {
  const scrollTop = window.scrollY;
  // Hide nav on scroll down, show on scroll up (only if custom nav exists)
  if (nav) {
    if (scrollTop > lastScrollY && scrollTop > 80) {
      nav.classList.add('nav-hidden');
    } else {
      nav.classList.remove('nav-hidden');
    }
  }
  lastScrollY = scrollTop;
});

// ==================================================
// SCROLL REVEAL — IntersectionObserver
// ==================================================
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');

      // Trigger stat counter animation if this is a stat card
      const statEl = entry.target.querySelector('.stat-number[data-count]');
      if (statEl && !statEl.dataset.animated) {
        animateCounter(statEl);
        statEl.dataset.animated = 'true';
      }
    }
  });
}, {
  threshold: 0.15,
  rootMargin: '0px 0px -40px 0px'
});

document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale').forEach(el => {
  revealObserver.observe(el);
});

// ==================================================
// ANIMATED STAT COUNTERS
// ==================================================
function animateCounter(el) {
  const target = parseInt(el.dataset.count);
  const duration = 1800;
  const start = performance.now();

  function update(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    // Ease out cubic
    const eased = 1 - Math.pow(1 - progress, 3);
    const current = Math.round(target * eased);
    el.textContent = current + '%';

    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  requestAnimationFrame(update);
}

function openVideoModal(src) {
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.src = src;
  modal.style.display = 'flex';
  requestAnimationFrame(() => {
    modal.classList.add('active');
    video.play();
  });
  document.body.style.overflow = 'hidden';
}

function closeVideoModal(e) {
  if (e && e.target !== e.currentTarget && !e.target.classList.contains('video-modal-close')) return;
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.pause();
  video.src = '';
  modal.classList.remove('active');
  setTimeout(() => { modal.style.display = 'none'; }, 300);
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeVideoModal({target: document.getElementById('videoModal'), currentTarget: document.getElementById('videoModal')});
});

// ==================================================
// VIDEO THUMBNAIL POSTER IMAGE FIX
// Replaces <video> elements in social proof thumbnails
// with lightweight <img> poster images. This prevents
// 15+ simultaneous video loads that saturate the browser
// connection pool, while showing proper preview images.
// Actual video only loads when user clicks to open modal.
// ==================================================
var videoPosterMap = {
  "3bc12f347dd34acc8d4faed93de16a53": "SleepKarma_FullCoverage_UGC_Original-Review-Cut_Joseph-Oehlschlaeger_1125_v2.jpg",
  "500c79c0b0d84e70ade10a2533e6f77a": "SleepKarma_FullCoverage_UGC_Original-Review_Simon-Says_0525_v1.jpg",
  "715b7c5830f6481397836f7c3b17a00b": "SleepKarma_FullCoverage_UGC_Original-Review-Cut_Laura-Evans_1225_v1.jpg",
  "fef13d3a8bf44449930cdaa4c05fb3a0": "SleepKarma_FullCoverage_UGC_Original-Review_Belle-Cogill_0425_v1.jpg",
  "f593012dbd5d4aa19cfe9288c0616b94": "SleepKarma_FullCoverage_UGC_Original-Review_Blake-Hansen_0425_v1.jpg",
  "641001e443eb4d18a32851dc68b204c5": "SleepKarma_FullCoverage_UGC_Original-Review-Old-Edit_Curtis-Diemer_0425_v1.jpg",
  "9591cfbe672945d09348ccd12a692ca8": "SleepKarma_FullCoverage_UGC_Travel-Case-Glamour_Laura-Ries_9x16_0125_v1.jpg",
  "85cd22af48274642b9031633c3415fc2": "SleepKarma_SlimProfile_UGC_Original-Review-Cut_Audrey-Spina_1125_v2.jpg",
  "21cc19f746a64ae3ae067bdc05e74174": "SleepKarma_SlimProfile_UGC_Original-Review_Audrey-Spina_9x16_1125_v1.jpg",
  "5e1fb548680540fd8acf68d20f38d300": "SleepKarma_SlimProfile_UGC_Original-Review_Zoe-McDaniel_9x16_1225_v1.jpg",
  "e2b0aaa25a384826acfaa3cdac318c93": "SleepKarma_FullCoverage_UGC_Three-Reasons-Mouth-Tape_Laura-Ries_9x16_0125_v1.jpg",
  "7740f6a86fa44e11899ec259240b75f2": "SleepKarma_FullCoverage_UGC_Original-Review_Curtis-Diemer_0425_v1.jpg",
  "93e20ae50541456a9649da6cc25d8a9f": "SleepKarma_SlimProfile_UGC_Fear-of-Full-Coverage_Laura-Ries_9x16_0125_v1.jpg",
  "545113687075466492b460f146c20428": "SleepKarma_FullCoverage_UGC_Read-This-For-Better-Sleep_Laura-Ries_9x16_0125_v1.jpg",
  "64b7f6b84ef5474db7152648159a363b": "SleepKarma_FullCoverage_UGC_Product-Suite-Explanation_Laura-Ries_9x16_0125_v1.jpg"
};

function optimizeVideoThumbnails() {
  var thumbs = document.querySelectorAll('.sp-video-thumb video');
  if (!thumbs.length) return;

  var cdnBase = 'https://cdn.shopify.com/s/files/1/0729/1243/7489/files/';

  thumbs.forEach(function(video) {
    var src = video.getAttribute('src') || '';
    // Extract the video ID from the CDN URL (32-char hex before .mp4)
    var match = src.match(/\/([a-f0-9]{32})\.mp4/);
    if (match && videoPosterMap[match[1]]) {
      var posterUrl = cdnBase + encodeURIComponent(videoPosterMap[match[1]]);
      var img = document.createElement('img');
      img.src = posterUrl;
      img.alt = 'Video preview';
      img.loading = 'lazy';
      img.className = 'sp-video-poster';
      // Replace video element with poster image
      video.parentElement.replaceChild(img, video);
    } else {
      // No poster found — remove video to prevent connection saturation
      video.parentElement.removeChild(video);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', optimizeVideoThumbnails);
} else {
  optimizeVideoThumbnails();
}

function toggleMoreReviews() {
  const grid = document.querySelector('.sp-grid');
  const btn = document.getElementById('sp-show-more-btn');
  const isExpanded = grid.classList.contains('sp-expanded');
  if (!isExpanded) {
    grid.classList.add('sp-expanded');
    btn.classList.add('expanded');
    btn.innerHTML = 'Show Less <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    // Stagger the animation
    grid.querySelectorAll('.sp-more-item').forEach(function(item, i) {
      item.style.animationDelay = (i * 0.06) + 's';
    });
  } else {
    grid.classList.remove('sp-expanded');
    btn.classList.remove('expanded');
    btn.innerHTML = 'Show More Reviews <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  }
}

// ==================================================
// DEEP LINK: ?variant=slim|full pre-selects tape style on load
// ==================================================
// Safe + additive: does NOTHING unless the URL has an explicit ?variant= (or ?tape= / ?style=)
// of "slim" or "full". With no/invalid param the page behaves exactly as before. When present,
// it routes through selectStyle() — the same path as a real tap — so UI, price, CTA all update.
// e.g. /pages/mouth-tape-a?variant=slim
function applyDeepLinkVariant() {
  try {
    var p = new URLSearchParams(window.location.search);
    var v = (p.get('variant') || p.get('tape') || p.get('style') || '').toLowerCase();
    if (v !== 'slim' && v !== 'full') return; // no/invalid param → no-op
    var el = document.querySelector('.variant-option[data-style="' + v + '"]');
    if (el && typeof selectStyle === 'function') selectStyle(el, v);
  } catch (e) {}
}

// Run at DOMContentLoaded. This script is defer-loaded, so at execution time readyState is
// 'interactive' (DCL not yet fired) — treat that as "wait for DCL" so that on the slim page this
// runs AFTER the slim section's own gallery-swap handler (no intermediate image flash).
if (document.readyState === 'complete') {
  applyDeepLinkVariant();
} else {
  document.addEventListener('DOMContentLoaded', applyDeepLinkVariant);
}